import React, { useState, useEffect } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { get } from '../../helpers/apiHelper';
import useAuthStore from '../../store/authStore';

const ProductSelector = ({ value, onChange }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [marcaId, setMarcaId] = useState(null);
    const { user } = useAuthStore();

    useEffect(() => {
        fetchMarcaId();
    }, []);

    useEffect(() => {
        if (marcaId) {
            loadProducts();
        }
    }, [marcaId]);

    const fetchMarcaId = async () => {
        try {
            const marcas = await get(`marcas/user/${user.userId}`);
            if (marcas.length > 0) {
                setMarcaId(marcas[0]._id);
            }
        } catch (error) {
            console.error('Error fetching marca:', error);
            setError('Error al cargar la información de la marca');
        }
    };

    const loadProducts = async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            params.append('activo', 'true');
            const url = `productos/${marcaId}/lista?${params.toString()}`;
            const data = await get(url);

            if (Array.isArray(data)) {
                setProducts(data);
            } else if (data.data && Array.isArray(data.data)) {
                setProducts(data.data);
            } else {
                setProducts([]);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const getCategoriaNombre = (categoria) => {
        if (!categoria) return 'Sin categoría';
        if (typeof categoria === 'string') return categoria;
        return categoria.nombre || 'Sin categoría';
    };

    if (loading) {
        return (
            <div className="bg-white rounded-lg shadow-sm p-6">
                <div className="flex items-center justify-center">
                    <FaSpinner className="animate-spin text-blue-500 text-xl" />
                    <span className="ml-2">Cargando productos...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-white rounded-lg shadow-sm p-6">
                <div className="text-red-500">
                    Error al cargar productos: {error}
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Selecciona un Producto
            </h3>

            {products.length === 0 ? (
                <p className="text-gray-500">
                    No hay productos disponibles. Añade productos primero en la sección de Inventario.
                </p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {products.map((product) => (
                        <div
                            key={product._id}
                            onClick={() => onChange(product._id)}
                            className={`border rounded-lg p-4 cursor-pointer transition-colors ${value === product._id
                                    ? 'border-blue-500 bg-blue-50'
                                    : 'border-gray-200 hover:border-blue-300'
                                }`}
                        >
                            {product.imagen && (
                                <img
                                    src={product.imagen}
                                    alt={product.nombre}
                                    className="w-full h-32 object-cover rounded mb-3"
                                />
                            )}
                            <h4 className="font-medium text-gray-900">
                                {product.nombre}
                            </h4>
                            {product.precio && (
                                <p className="text-gray-600 text-sm mt-1">
                                    Precio: {product.precio}€
                                </p>
                            )}
                            <span className="inline-block mt-2 px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded">
                                {getCategoriaNombre(product.categoria)}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductSelector; 